import * as Yup from "yup";

export const ADD_AUTHOR_SCHEMA = Yup.object().shape({
  firstName: Yup.string().required(
    "Director first name is required."
  ),
  secondName: Yup.string().required(
    "Director second name is required."
  ),
  email: Yup.string()
    .email("Please enter valid email")
    .required("Author Email is required.")
});

export const EDIT_AUTHOR_SCHEMA = Yup.object().shape({
  firstName: Yup.string().required(
    "Director first name is required."
  ),
  secondName: Yup.string().required(
    "Director second name is required."
  )
});

export const getInitialValues = (admin) => {
  return {
    firstName: admin?.firstName || "",
    secondName: admin?.secondName || "",
    email: admin?.email || ""
  };
};
